import * as e from "react";
import { i as n, E as a, x as r, d as t, c } from "../createReactComponent-58f9bea8.mjs";
const i = n`
  :host {
    --exo-component-container-background: var(--exo-color-background);
    --exo-component-container-padding: calc(2 * var(--exo-spacing-medium));
    --exo-component-container-min-width: calc(0.5 * var(--exo-size-1));
    --exo-component-container-min-height: calc(0.5 * var(--exo-size-1));
    --exo-component-container-box-shadow: var(--exo-color-shadow-weak);
    --exo-component-container-border-radius: calc(
      var(--exo-radius-large) - var(--exo-radius-small)
    );
    --exo-component-container-border: var(--exo-spacing-4x-small) solid
      var(--exo-color-border-secondary);
  }

  :host .container {
    background: var(--exo-component-container-background);
    padding: var(--exo-component-container-padding);
    min-width: var(--exo-component-container-min-width);
    min-height: var(--exo-component-container-min-height);
    box-shadow: var(--exo-component-container-box-shadow);
    border-radius: var(--exo-component-container-border-radius);
    border: var(--exo-component-container-border);
  }
`;
class o extends a {
  render() {
    return r`<div class="container">
      <slot></slot>
    </div>`;
  }
}
o.styles = i;
const s = t("ex-container", o), m = c({ tagName: "ex-container", elementClass: o, react: e, events: {}, displayName: "ExContainer", registerWebComponent: s });
export {
  m as ExContainer,
  s as register
};
